import { Button, Grid, SvgIcon, Tab, Tabs } from '@mui/material';
import TransportCostPage from './components/TransportCostPage';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from '../../assets';
import { ActiveTab } from '../../enums/ActiveTab';
import { useNavigate } from 'react-router-dom';
import { UserContext } from './../../components/shared/useUser';
import PageTitle from '../../components/shared/PageTitle';
import PageArea from '../../components/shared/PageArea';
import AddTransportCost from './components/AddTransportCost';
import { theme } from '../../theme';

const TransportCostDetails = () => {
  const [active, setActive] = useState<ActiveTab>(ActiveTab.Active);
  const [refreshKey, setRefreshKey] = useState(0);
  const { hasPermissionTo } = useContext(UserContext);
  const { t } = useTranslation('common');
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleTabChange = (event: React.SyntheticEvent, newValue: ActiveTab) => {
    setActive(newValue);
  };
  const handleClick = () => {
    setDialogOpen(true);
  };

  return (
    <PageArea>
      <Grid container>
        <Grid item
          xs={12} >
          <PageTitle>
            {t('transportCosts.title')}
          </PageTitle>
        </Grid>
        <Grid container
          item
          xs={12}>
          <Grid item
            xs={8}>
            <Tabs value={active}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
              aria-label="primary tabs example">
              <Tab label={t('active')}
                value={ActiveTab.Active} />
              <Tab label={t('archived')}
                value={ActiveTab.Inactive} />
            </Tabs>
          </Grid>
          {
            hasPermissionTo(['FinancialManagementWrite']) &&
            <Grid item
              xs={4}
              sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button 
                variant='primary'
                size='lg'
                sx={{ mb: 4 }}
                startIcon={<SvgIcon><Plus /></SvgIcon>}
                onClick={() => handleClick()} >{t('transportCosts.createNew')}</Button>
            </Grid>
          }
          <Grid item
            sx={{ border: '1px solid', borderColor: theme.palette.custom.gray[300] }}
            spacing={5}
            xs={12}>
            <TransportCostPage activeTab={active}
              refreshKey={refreshKey} />
          </Grid>
        </Grid>
      </Grid>
     
      <AddTransportCost open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onCreated={() => {
          setDialogOpen(false);
          setRefreshKey(prev => prev + 1); // triggers grid reload
        }} />
    </PageArea>
  );
};

export default TransportCostDetails;